export default __webpack_public_path__ + "static/media/SPIRIT.1a3ee00b.png";